var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToBeUnique(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 269.96,
    height: 69.89,
    viewBox: "0 0 269.96 69.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 117.676,
    height: 41.454,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_95",
    "data-name": "Rect\\xE1ngulo 95",
    width: 145.072,
    height: 69.89,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_624",
    "data-name": "Grupo 624",
    transform: "translate(-901.162 -6255.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621",
    transform: "translate(901.162 6264.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_616",
    "data-name": "Grupo 616",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_560",
    "data-name": "Trazado 560",
    d: "M8.957,0H.073L0,31.093c-.018,6.679,4.211,10.345,9.96,10.361a32.5,32.5,0,0,0,7.063-1.227v-5.61a31.006,31.006,0,0,1-4.951-.343c-1.911-.5-3.192-1.706-3.183-4.666L8.918,16.8l8.536.02.018-6.214-8.536-.02Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_561",
    "data-name": "Trazado 561",
    d: "M88.693,19.285a9.051,9.051,0,0,0,7.09-8.977C95.8,4,90.2.071,81.207.048L62.4,0l-.105,40.94H81.745c9.463.026,15.432-4.282,15.448-11.291a9.983,9.983,0,0,0-8.5-10.363M71.609,7.557l9.112.023c3.5-.048,5.6,1.593,5.6,4.4-.007,2.861-2.116,4.55-5.619,4.541L71.586,16.5ZM80.654,33.4l-9.112-.023.026-9.7,9.111.023c4.321-.046,7.005,1.772,7,4.75-.009,3.154-2.7,4.96-7.024,4.949",
    transform: "translate(-37.038 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_562",
    "data-name": "Trazado 562",
    d: "M175.942,24.184l19.668.05.018-7.644-19.667-.051.023-8.872,21.884.057L197.888,0H166.676V40.948h31.751l.018-7.658-22.528-.057Z",
    transform: "translate(-99.102 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_563",
    "data-name": "Trazado 563",
    d: "M271.129,78.251a4.865,4.865,0,1,0,4.853,4.89,4.785,4.785,0,0,0-4.853-4.89m-.021,8.785a3.931,3.931,0,1,1,3.9-3.9,3.855,3.855,0,0,1-3.9,3.9",
    transform: "translate(-158.307 -46.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_564",
    "data-name": "Trazado 564",
    d: "M277.77,85.895c0-.9-.729-1.481-1.822-1.484L273.88,84.4l-.012,4.466.973,0,0-1.432.729,0,1.258,1.436,1.168,0-1.382-1.533a1.5,1.5,0,0,0,1.152-1.453m-1.831.674-1.092,0,0-1.284,1.092,0c.506,0,.846.246.845.632s-.341.654-.848.652",
    transform: "translate(-162.836 -50.185)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_623",
    "data-name": "Grupo 623",
    transform: "translate(1026.05 6255.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_622",
    "data-name": "Grupo 622",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_565",
    "data-name": "Trazado 565",
    d: "M12.445,32.831a3.125,3.125,0,0,1,.925,2.4c0,1.99-1.345,3.317-4.037,3.317C4.036,38.552,0,32.334,0,24.54,0,9.783,10.933,0,24.808,0A19.476,19.476,0,0,1,44.236,19.483c0,11.359-7.486,19.234-16.652,19.234A14.083,14.083,0,0,1,13.538,24.208c0-8.374,5.3-15.835,13.961-15.835,7.4,0,10.849,3.731,10.849,9.2,0,15.173-26.323,19.565-26.323,30.344,0,2.654,1.093,4.891,5.551,4.891,6.981,0,14.465-6.382,23.716-19.648,12.53-17,11.269-24.292,16.651-24.292a2.094,2.094,0,0,1,2.018,2.239c0,4.891-6.727,13.844-16.315,23.545C37.76,40.707,34.816,45.1,34.816,49c0,2.238,1.008,3.648,3.448,3.648,5.213,0,7.821-5.969,11.689-13.6l.167-.332h.085l-.169.332c-3.868,7.628-6.56,13.68-11.773,13.68-2.944,0-4.458-1.74-4.458-4.477,0-2.9,2.017-7.379,7.569-15.089-9.168,13.266-16.819,19.732-23.8,19.732-5.047,0-6.728-2.652-6.728-5.8,0-11.109,21.361-17.824,21.361-32,0-3.979-2.27-5.885-6.306-5.885-7.149,0-12.279,6.715-12.279,15.005A14,14,0,0,0,27.584,38.634c9.165,0,16.566-7.875,16.566-19.151A19.385,19.385,0,0,0,24.808.083C10.933.083.084,9.866.084,24.54c0,7.711,3.952,13.929,9.25,13.929,2.692,0,3.953-1.327,3.953-3.234a3.125,3.125,0,0,0-.925-2.4Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_566",
    "data-name": "Trazado 566",
    d: "M44.165,51.283c-1.766,0-2.354-1.244-2.354-2.571,0-4.061,15.305-14.591,15.305-24.207,0-2.074-.841-2.406-1.514-2.406-2.944,0-8.494,12.271-9.419,14.094l-.169.332H45.93l.169-.332c.925-1.907,6.728-14.508,9.756-14.508,1.85,0,2.1,1.907,2.1,3.234,0,4.726-3.112,11.523-5.13,15.005.841-1.575,9.587-13.43,13.287-13.43,1.766,0,2.608,1.41,2.608,3.4,0,8.124-12.446,14.508-12.446,18.487,0,1.078.756,1.327,1.513,1.327,4.122,0,10.008-9.037,12.111-13.183l.167-.332h.084l-.167.332c-2.1,4.229-8.41,14.012-13.54,14.012-2.69,0-3.448-1.658-3.448-3.648,0-5.8,13.793-14.259,13.793-18.487,0-1.078-.5-1.493-1.345-1.493-3.028,0-11.438,11.026-12.615,13.1-3.365,5.97-5.971,11.276-8.662,11.276",
    transform: "translate(4.865 2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_567",
    "data-name": "Trazado 567",
    d: "M64.109,48.864c0-5.389,7.654-21.555,11.943-21.555,1.6,0,1.934,1.16,1.934,2.321,0,5.057-13.036,12.435-13.036,19.4,0,1.575.925,1.74,1.515,1.74,4.709,0,9.839-9.45,11.942-13.6l.167-.332h.085l-.169.332C76.387,41.4,71.089,51.1,65.96,51.1c-1.431,0-1.851-1.16-1.851-2.238M84.124,18.272a3.886,3.886,0,0,1-3.532,3.814,1.863,1.863,0,0,1-2.018-2.072,3.9,3.9,0,0,1,3.617-3.9,1.938,1.938,0,0,1,1.934,2.156",
    transform: "translate(7.46 1.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_568",
    "data-name": "Trazado 568",
    d: "M97.595,36.025c-4.71,9.286-11.942,12.851-13.036,19.151-.841,6.467-1.261,11.691-4.289,11.691-.925,0-2.271-.747-2.271-3.152,0-5.389,6.309-17.493,12.615-26.861-1.934,2.9-10.68,13.016-14.632,13.016-1.767,0-2.608-1.41-2.608-3.4,0-8.788,12.363-20.478,23.548-20.478,2.018,0,2.356,1.16,2.356,2.238,0,1.742-4.289,3.9-7.654,8.456A40.706,40.706,0,0,0,84.643,54.43c1.431-5.8,8.5-9.866,12.868-18.406l.167-.332h.084Zm-20.52,13.1c3.616,0,12.531-10.777,13.792-12.768.841-1.326,2.272-3.731,3.112-5.472-8.747,2.571-18.25,11.938-18.25,16.748,0,1.078.5,1.493,1.346,1.493",
    transform: "translate(8.538 3.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_569",
    "data-name": "Trazado 569",
    d: "M96.122,36.041h-.085l.169-.332c1.178-2.321,4.541-9.864,9.335-9.864,1.85,0,2.775,1.326,2.775,3.316,0,5.8-12.7,14.259-12.7,18.487,0,1.078.5,1.493,1.345,1.493,3.532,0,11.942-10.695,12.951-12.767,2.859-5.888,5.213-10.363,7.906-10.363,1.766,0,2.354,1.243,2.354,2.569,0,4.062-14.381,13.6-14.381,21.307,0,1.078.5,1.907,1.514,1.907,4.121,0,10.68-13.928,11.606-15.752l.167-.332h.085l-.169.332c-.925,1.907-7.736,16.167-11.942,16.167-1.261,0-2.1-.995-2.1-2.736,0-2.985,2.944-9.451,4.962-13.015-.841,1.906-9.84,13.429-14.045,13.429-1.766,0-2.607-1.409-2.607-3.4,0-8.124,12.448-14.508,12.448-18.486a1.4,1.4,0,0,0-1.515-1.494c-3.447,0-6.811,6.964-7.905,9.2Z",
    transform: "translate(10.853 3.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_570",
    "data-name": "Trazado 570",
    d: "M131.362,36.077l.167-.332h.084l-.167.332C129.344,40.305,123.373,50,117.737,50c-2.017,0-3.532-1.16-3.532-4.975,0-9.451,8.411-19.483,14.551-19.483,1.766,0,3.028.829,3.028,2.9,0,7.212-9.168,11.69-15.727,12.27a13.645,13.645,0,0,0-1.009,5.14c0,2.652,1.6,3.731,3.28,3.731,5.131,0,10.933-9.369,13.036-13.514m-6.392-3.648c-2.774,0-6.9,3.317-8.914,8.209,6.14-.581,10.764-3.483,10.764-6.551,0-1.16-.757-1.658-1.85-1.658",
    transform: "translate(13.29 2.972)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToBeUnique);
export default __webpack_public_path__ + "static/media/toBeUnique.36ef77d50ceeaf55f97eb7cb5a58eb46.svg";
export { ForwardRef as ReactComponent };